import { render } from "./oobfilter.vue?vue&type=template&id=70f54c5a&scoped=true"
import script from "./oobfilter.vue?vue&type=script&lang=js"
export * from "./oobfilter.vue?vue&type=script&lang=js"

import "./oobfilter.vue?vue&type=style&index=0&id=70f54c5a&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70f54c5a"]])

export default __exports__